// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.share-confirmation-popup .buttons {
  margin-top: 3rem;
}
.share-confirmation-popup h3 {
  margin-bottom: 1.3rem;
}`, "",{"version":3,"sources":["webpack://./src/kit/components/Popups/ShareAmendConfirmationPopup/index.scss"],"names":[],"mappings":"AACE;EACE,gBAAA;AAAJ;AAGE;EACE,qBAAA;AADJ","sourcesContent":[".share-confirmation-popup {\n  .buttons {\n    margin-top: 3rem;\n  }\n\n  h3 {\n    margin-bottom: 1.3rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
